export default class Roles {
    public static readonly Administrators: string = 'Administrators';
    public static readonly CargoControl: string = 'Cargo Control';
    public static readonly CargoOffice: string = 'Cargo Office';
    public static readonly Drivers: string = 'Drivers';
    public static readonly Mail: string = 'Mail';
    public static readonly StationAdmins: string = 'Station Administrators';
}

/** Page-level role lists; the router guard (definePage meta.roles) and the menu (v-role) must agree. */
export class RoleGroups {
    public static readonly Transports: readonly string[] = [ Roles.Administrators, Roles.StationAdmins, Roles.CargoControl, Roles.CargoOffice, Roles.Mail ];
    public static readonly Driver: readonly string[] = [ Roles.Drivers ];
    public static readonly Maintenance: readonly string[] = [ Roles.Administrators, Roles.StationAdmins ];
    public static readonly ApiDocs: readonly string[] = [ Roles.Administrators ];
}
